import { SeverityType } from '~/components/SnackbarAlert/types';
import { ActionKeys } from './constants';

export interface AddSnackbarMessagePayload {
  message: string;
  i18n?: boolean;
  severity: SeverityType;
}

export function addSnackbarMessage(payload: AddSnackbarMessagePayload) {
  return <const>{
    type: ActionKeys.SNACKBAR_ADD_MESSAGE,
    payload: {
      message: payload.message,
      i18n: payload.i18n || false,
      severity: payload.severity,
    },
  };
}

export type SnackbarActions = ReturnType<typeof addSnackbarMessage>;
